import { render, staticRenderFns } from "./SimilarHotels.vue?vue&type=template&id=702e593e"
import script from "./SimilarHotels.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarHotels.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SimilarHotels.vue?vue&type=style&index=0&id=702e593e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports